import "./LandingStyles.css";
import LandingData from "./LandingData";

function Landing (){
return (
    <div className="Header">
        <div className="heading">
        <h4>Servicing your plan </h4>
        <p>At Multishade Insurance, we believe in providing peace of mind to our clients through comprehensive 
            insurance solutions tailored to their unique needs. With years of experience and a commitment 
            to customer satisfaction, we are dedicated to helping you safeguard your family, property, and business</p>

        </div>
        
    <div className="Headercard">
        <LandingData
            icon ="fa-brands fa-pagelines"
            heading="Energy, Oil & Gas"
            text="Comprehensive coverage for energy production and distribution 
            to protect against risks and financial losses. "
        />

        <LandingData
            icon ="fa-solid fa-ship"
            heading="Port Liabilities"
            text="Coverage designed to protect ports and terminal operations from ships, cargo and third-party property"
        />
        <LandingData
            icon = "fa-solid fa-anchor"
            heading="Marine & Air Cargo"
            text="Tailored insurance for vessels and cargo, ensuring protection aganist damage, loss and liability at sea"
        />
       
         <LandingData
            icon ="fa-solid fa-plane"
            heading="Aviation Insurance"
            text="Specialized insurance for aircraft operators, providing coverage for liability, hull damage and passanger safety"
        />

   
    </div>
    </div>
);
}

export default Landing;